import * as Yup from "yup";
import dayjs from "dayjs";

export const advancedValidationSchema = Yup.object({
    // companyName: Yup
    //     .string()
    //     .required("Required"),
    // documentNo: Yup
    //     .string()
    //     .required("Required"),
})

export const advancedInitialValues = {
    companyName: "",
    documentNo: "",
}

export const validationSchema = Yup.object({
    locationIds: Yup
        .array()
        .required("Required"),
    // createDateFrom: Yup
    //     .string()
    //     .required("Required"),
    // createDateTo: Yup
    //     .string()
    //     .required("Required"),
    dateFrom: Yup
        .string()
        .required("Required"),
    dateTo: Yup
        .string()
        .required("Required"),
})

export const initialValues = {
    locationIds: [],
    createDateFrom: "",
    createDateTo: "",
    dateFrom: "",
    dateTo: "",

    profileName: "",
    deliveryProfileName: "",
    billingProfileName: ""
}